export const GET_PRODUCT = "GET_PRODUCT"
export const GET_PRODUCT_BY_ID = "GET_PRODUCT_BY_ID"
export const GET_PRODUCT_BY_ID_SUCCESS = "GET_PRODUCT_BY_ID_SUCCESS"
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS"
export const GET_PRODUCT_ERROR = "GET_PRODUCT_ERROR"

export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST"
export const GET_PRODUCT_LIST_SUCCESS = "GET_PRODUCT_LIST_SUCCESS"
export const GET_PRODUCT_LIST_ERROR = "GET_PRODUCT_LIST_ERROR"
